export const botKnowledgeBase = {
    initial: {
        text: "¡Hola! Soy el asistente virtual de Lignum. ¿Cómo puedo ayudarte hoy?",
        replies: ["¿Qué es Lignum?", "¿Cómo hago un retiro?", "¿Es seguro invertir?", "Tengo un problema"]
    },
    "Saludo": {
        userText: "Hola",
        keywords: ["hola", "buenos dias", "buenas tardes", "buenas noches", "hey", "saludos"],
        text: "¡Hola! Soy el asistente de Lignum. ¿En qué puedo ayudarte? Puedes elegir una de las siguientes opciones o escribir tu pregunta.",
        replies: ["¿Qué es Lignum?", "¿Cómo hago un retiro?", "¿Es seguro invertir?", "Tengo un problema"]
    },
    "¿Qué es Lignum?": {
        userText: "Explícame qué es Lignum",
        keywords: ["lignum", "qué es", "funciona", "plataforma"],
        text: "Lignum es una plataforma de crowdfunding que te permite invertir capital y recibir ganancias diarias (de lunes a viernes) hasta duplicar tu inversión. También puedes obtener comisiones por referir a otros usuarios.",
        replies: ["¿Cómo hago un retiro?", "¿Es seguro invertir?", "Volver al inicio"]
    },
    "¿Cómo funciona?": {
        userText: "Explícame cómo funciona",
        keywords: ["funciona", "cómo es", "invertir"],
        text: "Lignum es una plataforma de crowdfunding. Inviertes un capital, y recibes ganancias diarias de lunes a viernes hasta duplicar tu inversión. También puedes ganar comisiones por referir a otros.",
        replies: ["¿Qué es el acelerador?", "¿Cómo hago un retiro?", "Volver al inicio"]
    },
    "¿Qué es el acelerador?": {
        userText: "Quiero saber sobre el acelerador",
        keywords: ["acelerador", "acelerar", "más rápido"],
        text: "El 'Acelerador' te permite recibir un porcentaje de ganancia diario más alto. Además, solo los acuerdos con acelerador activo pueden sumar las comisiones de tu equipo para alcanzar la meta del 200% más rápido.",
        replies: ["¿Cómo funciona?", "¿Cuáles son los fees?", "Volver al inicio"]
    },
    "¿Cómo hago un retiro?": {
        userText: "Necesito hacer un retiro",
        keywords: ["retiro", "retirar", "sacar dinero", "cobrar"],
        text: "Para solicitar un retiro, ve a la sección 'Movimientos' en tu menú. Allí verás tu 'Disponible para retiro' y un botón para 'Solicitar Retiro'. El monto mínimo es de $50 y tiene un fee del 10%.",
        replies: ["¿Cuáles son los fees?", "Volver al inicio"]
    },
    "¿Es seguro invertir?": {
        userText: "Preguntar sobre la seguridad",
        keywords: ["seguro", "seguridad", "riesgo", "confiable"],
        text: "En Lignum, la seguridad de nuestros usuarios es la máxima prioridad. Nuestra plataforma está diseñada con robustas medidas de seguridad y es gestionada activamente por un equipo de administradores que supervisa todas las operaciones, desde las inversiones hasta los retiros. Fomentamos un entorno transparente y, aunque toda inversión implica un componente de riesgo, nos esforzamos por ofrecer una plataforma estable y confiable para que puedas alcanzar tus metas financieras.",
        replies: ["¿Qué es Lignum?", "¿Cómo funciona?", "Volver al inicio"]
    },    
    "¿Cuáles son los fees?": {
        userText: "Quiero saber sobre las comisiones/fees",
        keywords: ["fee", "fees", "comisión", "comisiones", "costo"],
        text: "El único fee que cobra la plataforma es un 10% sobre el monto de cada retiro que solicites. No hay comisiones por invertir o por mantenimiento de cuenta.",
        replies: ["¿Cómo hago un retiro?", "Volver al inicio"]
    },
    "Tengo un problema": {
        userText: "Necesito ayuda con un problema",
        keywords: ["problema", "ayuda", "soporte", "error"],
        text: "Entendido. Para problemas específicos con tu cuenta, participaciones o retiros, por favor dirígete a la sección de 'Soporte' en el menú principal para crear un ticket. Nuestro equipo te atenderá personalmente.",
        replies: ["Volver al inicio"]
    },
    default: {
        text: "No he entendido tu consulta. Por favor, intenta con una de las opciones o, si necesitas ayuda personalizada, ve a la sección de 'Soporte'.",
        replies: ["¿Qué es Lignum?", "¿Cómo hago un retiro?", "¿Es seguro invertir?"]
    }
};